import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, ArrowUpRight } from "lucide-react";
import { SITE, IMAGES, NAV } from "../data/site";
import { scrollToId } from "./Header";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16.6 5.82a4.28 4.28 0 0 1-1.02-2.82h-3.3v12.9a2.35 2.35 0 1 1-2.35-2.35c.2 0 .4.03.59.08v-3.4a5.7 5.7 0 0 0-.59-.03A5.75 5.75 0 1 0 15.28 16V9.7a7.5 7.5 0 0 0 4.4 1.42V7.8a4.28 4.28 0 0 1-3.08-1.98z" />
  </svg>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-brand-ink text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="bg-white rounded-2xl p-3 inline-block">
            <img src={IMAGES.logo} alt="Se Klart Ut" className="h-12 w-auto object-contain" />
          </div>
          <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-sm">
            Professionell fönsterputs och utvändig rengöring i hela Skaraborg – för privatpersoner och företag. Skinande rent, varje gång.
          </p>
          <div className="mt-6 flex gap-3">
            <a href={SITE.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="h-11 w-11 rounded-full bg-white/10 hover:bg-brand-blue flex items-center justify-center transition-colors">
              <Instagram className="h-5 w-5" strokeWidth={1.75} />
            </a>
            <a href={SITE.tiktok} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok" aria-label="TikTok" className="h-11 w-11 rounded-full bg-white/10 hover:bg-brand-blue flex items-center justify-center transition-colors">
              <TikTokIcon className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Utforska</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <a href={n.to} onClick={(e) => { e.preventDefault(); scrollToId(n.to); }} className="text-white/70 hover:text-white text-sm transition-colors">{n.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Tjänster</h4>
          <ul className="space-y-3">
            <li><Link to="/tjanster/fonsterputs" className="text-white/70 hover:text-white text-sm transition-colors">Fönsterputs</Link></li>
            <li><Link to="/tjanster/solpaneltvatt" className="text-white/70 hover:text-white text-sm transition-colors">Solpaneltvätt</Link></li>
            <li><Link to="/tjanster/altantvatt" className="text-white/70 hover:text-white text-sm transition-colors">Altantvätt</Link></li>
            <li><Link to="/tjanster/marktvatt" className="text-white/70 hover:text-white text-sm transition-colors">Marktvätt</Link></li>
            <li><Link to="/boka-offert" className="group inline-flex items-center gap-1.5 text-brand-ice hover:text-white text-sm font-medium transition-colors">Boka fönsterputs <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Kontakt</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={SITE.phoneHref} className="flex items-center gap-2.5 text-white/70 hover:text-white transition-colors"><Phone className="h-4 w-4 text-brand-ice" strokeWidth={1.75} /> {SITE.phone}</a></li>
            <li><a href={SITE.emailHref} className="flex items-center gap-2.5 text-white/70 hover:text-white transition-colors"><Mail className="h-4 w-4 text-brand-ice" strokeWidth={1.75} /> {SITE.email}</a></li>
            <li className="text-white/70">Skövde · Hela Skaraborg</li>
          </ul>
          <p className="mt-6 text-xs text-white/40">Försäkrat · Kostnadsfri offert · Se Klart Ut-garanti</p>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <p>© {new Date().getFullYear()} Se Klart Ut. Alla rättigheter förbehållna.</p>
        <p>Fönsterputs & utvändig rengöring i hela Skaraborg</p>
      </div>
    </div>
  </footer>
);

export default Footer;
